import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=0fcdfaff&"
import script from "./Emails.vue?vue&type=script&lang=js&"
export * from "./Emails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports